import { createStore, applyMiddleware, compose } from 'redux';
import createSagaMiddleware from 'redux-saga';
import createHistory from 'history/createBrowserHistory';
import { saga as routerSaga } from 'redux-saga-first-router';

import * as authTypes from 'auth/types';
import reducer from 'reducers';
import mainSaga from 'sagas';
import routes from 'app/routes';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const sagaMiddleware = createSagaMiddleware();
const history = createHistory();

const resetEnhancer = rootReducer => (state, action) => {
  if (action.type !== authTypes.RESET_STORE) return rootReducer(state, action);

  const newState = rootReducer(undefined, {});
  return newState;
};

const configureStore = () => {
  const middleware = [sagaMiddleware];

  const store = createStore(
    resetEnhancer(reducer),
    {},
    composeEnhancers(
      applyMiddleware(...middleware),
    )
  );

  sagaMiddleware.run(mainSaga);
  sagaMiddleware.run(routerSaga, routes, history);

  return store;
}


export default configureStore;
